import script from "./TopArticlesCards.vue?vue&type=script&setup=true&lang=js"
export * from "./TopArticlesCards.vue?vue&type=script&setup=true&lang=js"

import "./TopArticlesCards.vue?vue&type=style&index=0&id=63b6def0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b6def0"]])

export default __exports__